<template>
  <div class="position-relative w-100">
    <slot name="dropzone"></slot>
    <editor-overlay
        v-if="editable"
        :active="editorSelected"
        :can-have-template="false"
        @editProperty="editProperty"
        @editTemplate="editTemplate"
        @removeBlock="$emit('removeBlock')"
    />
    <div v-if="!vSTAGEContext" class="mb-2">
      {{ $t('vform.partInfovStageOnly') }}
    </div>
    <div v-if="vSTAGEContext" class="mb-2 d-flex" style="flex-direction: column">
      <div v-if="!instanceId">
        {{ $t("vform.selectInstanceFromScene") }}
      </div>
      <part-info-display
          v-if="instanceId"
          class="mb-2"
          :background-color="config.backgroundColor ? config.backgroundColor : ''"
          :border-color="config.borderColor ? config.borderColor : (fontColor ? fontColor : (contrastColor ? contrastColor : ''))"
          :font-color="config.fontColor ? config.fontColor : fontColor"
          :item-name="instanceName"
          :meta-fields="config.metaFields"
          :meta-values="instanceMetaValues"
      />
      <!--<div v-for="(item, key, index) in smashedInstanceMetaSets" v-if="instanceId" :key="index"
           class="">
        <label class="meta-field-label">{{ key }}</label>
        <label v-if="item" class="meta-field-value"> {{ item }}</label>
        <label v-else class="meta-field-value"> - </label>
      </div>-->
    </div>
  </div>
</template>

<script>
import ElementMixin from "@/components/vForm/mixins/ElementMixin.js.vue";
import MetaSetsMixin from "@/components/mixins/MetaSetsMixin.js";
import EditorOverlay from "./EditorOverlay";
import PartInfoDisplay from "@/components/vForm/PartInfoDisplay.vue";
import {mapState} from "vuex";
export default {
  name: "PART_INFO",
  components: {PartInfoDisplay, EditorOverlay},
  mixins: [ElementMixin, MetaSetsMixin],
  data() {
    return {
      assetId: null,
      projectId: null,
      instanceMetaSets: null,
      assetMetaSets: null,
      smashedInstanceMetaSets: null,
      instanceName: '',
      instanceMetaValues: []
    };
  },
  computed: {
    ...mapState({
      instanceId: state => state.communicationAdapter.vSTAGE.selectedObjectInstanceId
    })
  },
  watch: {
    instanceId(val) {
      this.instanceId = val;
      if (this.instanceId) {
        this.loadInstance();
      }
    }
  },
  mounted() {
    this.$emit('increasePostLoadingCounter');
    if (this.instanceId) {
      this.loadInstance();
    }
  },
  methods: {
    async loadInstance() {
      this.assetId = null;
      this.smashedInstanceMetaSets = null;
      this.instanceName = 'vform.selectInstanceNotFound';
      // load instance to retrieve assetId and projectId
      await this.$store.dispatch('clientGetCrossProjectInstances', {
        filter: `id eq ${this.instanceId}`,
        include: ['squashedMeta']
      }).then(data => {
        if (data[0]) {
          this.instanceName = data[0].name;
          this.projectId = data[0].projectId;
          this.assetId = data[0].assetId;
          this.instanceMetaValues = data[0].squashedMetaFields;
        }
      });

      if (this.assetId) {
        // load asset
        await this.$store.dispatch('clientLoadAsset', {
          id: this.assetId,
          include: 'metaSets'
        }).then(asset => {
          const {metaSets} = asset;
          this.assetMetaSets = metaSets;
        });
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.meta-field-label {
  font-weight: 600;
  min-width: 150px;
}

.meta-field-value {
  min-width: 200px;
}
</style>